import { render, staticRenderFns } from "./AutoShutdown.vue?vue&type=template&id=48723e93"
import script from "./AutoShutdown.vue?vue&type=script&lang=ts"
export * from "./AutoShutdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports